import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ModernNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY === 0) {
        // At the top of the page, always show the navbar
        setIsVisible(true);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up - show navbar
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px - hide navbar
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ease-in-out ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
      style={{
        background: '#f8f8f8ff', /* Dark background color */
        borderBottom: '1px solid #c4c4c4ff' /* Darker border */
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex items-center justify-between md:justify-center h-16">
          {/* Logo */}
          <div className="flex-grow flex justify-center md:flex-grow-0">
            <Link to="/" className="flex items-center">
              <img
                src="/saltlogo.png"
                alt="SaltFishy Logo"
                className="h-14 w-auto"
                style={{ height: '56px', width: '' }}
              />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              className="p-2 text-gray-800 bg-white/80 hover:bg-white/90 rounded-lg shadow-sm border border-white/30 transition-all"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-2">
            <Link 
              to="/" 
              className="px-4 py-2 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/30 transition-all duration-200 hover:shadow-md no-underline"
              style={{ textDecoration: 'none' }}
            >
              Home
            </Link>
            <Link 
              to="/shop" 
              className="px-4 py-2 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/30 transition-all duration-200 hover:shadow-md no-underline"
              style={{ textDecoration: 'none' }}
            >
              Collection
            </Link>
            <Link 
              to="/about" 
              className="px-4 py-2 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/30 transition-all duration-200 hover:shadow-md no-underline"
              style={{ textDecoration: 'none' }}
            >
              About
            </Link>
            <Link 
              to="/care-guide" 
              className="px-4 py-2 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/30 transition-all duration-200 hover:shadow-md no-underline"
              style={{ textDecoration: 'none' }}
            >
              Care Guide
            </Link>
            <Link 
              to="/contact" 
              className="px-4 py-2 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/30 transition-all duration-200 hover.shadow-md no-underline"
              style={{ textDecoration: 'none' }}
            >
              Contact
            </Link>
          </nav>
        </div>

        {/* Mobile Navigation Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden">
            <nav className="pt-2 pb-3 space-y-1">
              <div className="flex flex-col items-center space-y-2 px-3">
                <Link
                  to="/"
                  className="block w-full px-4 py-3 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/40 transition-all duration-200 hover:shadow-md text-center no-underline"
                  onClick={() => setIsMenuOpen(false)}
                  style={{ textDecoration: 'none' }}
                >
                  Home
                </Link>
                <Link
                  to="/shop"
                  className="block w-full px-4 py-3 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/40 transition-all duration-200 hover:shadow-md text-center no-underline"
                  onClick={() => setIsMenuOpen(false)}
                  style={{ textDecoration: 'none' }}
                >
                  Collection
                </Link>
                <Link
                  to="/about"
                  className="block w-full px-4 py-3 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/40 transition-all duration-200 hover:shadow-md text-center no-underline"
                  onClick={() => setIsMenuOpen(false)}
                  style={{ textDecoration: 'none' }}
                >
                  About
                </Link>
                <Link
                  to="/care-guide"
                  className="block w-full px-4 py-3 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/40 transition-all duration-200 hover:shadow-md text-center no-underline"
                  onClick={() => setIsMenuOpen(false)}
                  style={{ textDecoration: 'none' }}
                >
                  Care Guide
                </Link>
                <Link
                  to="/contact"
                  className="block w-full px-4 py-3 text-sm font-medium text-white bg-gray-700/20 hover:bg-gray-600/30 rounded-lg shadow-sm border border-gray-600/40 transition-all duration-200 hover:shadow-md text-center no-underline"
                  onClick={() => setIsMenuOpen(false)}
                  style={{ textDecoration: 'none' }}
                >
                  Contact
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default ModernNavbar;
